export default __webpack_public_path__ + "static/media/phone-frame.46364352.png";